import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/modal";
import { Input } from "../../components/form-elements";
import { userData } from "../../data/fake_login_data";
import { BASE_URL } from "../../constants";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";

const Cards = () => {
  const navigate = useNavigate();
  const [newSrc, setNewSrc] = useState(null);
  const [srcObj, setSrcObj] = useState(null);
  const [file, setFile] = useState(null);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(false);
  const [Courses, setCourses] = useState(null);
  const [Chapters, setChapters] = useState(null);
  const [newCardData, setNewCardData] = useState({
    admin_id: userData?.user_id,
    access_token: userData?.access_token,
    order_title: null,
    count: null,
    sub_type: "course", //'course', 'chapter'
    courses_ids: null,
  });
  // setNewCardData
  const [createCards, setCreateCards] = useState(false);
  // setCreateCards
  const [cardsPosition, setCardsPosition] = useState({
    cardCode: {
      top: 49,
      left: 82,
      font: 17,
    },
    cardId: {
      top: 166,
      left: 19,
      font: 13,
    },
    cardImage: {
      width: 385,
      height: 248,
    },
    templet_name: null,
  });

  useEffect(() => {
    if (srcObj) {
      setNewSrc(URL.createObjectURL(srcObj));
      setFile(srcObj);
    }
  }, [srcObj]);
  useEffect(() => {
    if (newCardData?.sub_type == "course") {
      getCourses();
    }

    if (newCardData?.sub_type == "chapter") {
      getChapters();
    }
  }, [newCardData?.sub_type]);
  const getCourses = async () => {
    const univsAndGradesChainsCourses = await axios.post(
      BASE_URL + "subscriptions/cards/select_courses.php",
      {
        admin_id: userData?.user_id,
        access_token: userData?.access_token,
      }
    );
    setCourses(univsAndGradesChainsCourses?.data?.message);
  };
  const getChapters = async () => {
    const univsAndGradesChainsCoursesChapters = await axios.post(
      BASE_URL + "courses/chapters/select_course_chapters.php",
      {
        admin_id: userData?.user_id,
        access_token: userData?.access_token,
      }
    );

    setChapters(univsAndGradesChainsCoursesChapters?.data?.message);
  };

  const createTemplate = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const formData = new FormData();
    formData.append("image", srcObj);
    try {
      const imageUpload = await axios.post(
        BASE_URL + "item_img_uploader.php",
        formData
      );
      if (imageUpload?.data?.status == "success") {
        const data_send = {
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          templet_name: cardsPosition.templet_name,
          image_url: imageUpload?.data?.message,
          card_width: cardsPosition.cardImage?.width,
          card_height: cardsPosition.cardImage?.height,
          code_fontsize: cardsPosition.cardCode?.font,
          code_top: cardsPosition.cardCode?.top,
          code_left: cardsPosition.cardCode?.left,
          id_fontsize: cardsPosition.cardId?.font,
          id_top: cardsPosition.cardId?.top,
          id_left: cardsPosition.cardId?.left,
        };
        axios
          .post(
            BASE_URL + "subscriptions/cards/design_templets/create_templet.php",
            JSON.stringify(data_send)
          )
          .then((res) => {
            if (res.data.status == 'success') {
              toast.success(res.data.message);
              // fetchData();
            } else if (res.data.status == 'error') {
              toast.error(res.data.message);
            } else {
              toast.error("Something Went Error");
            }
          });
      }
    } catch (e) {}
  };
  return (
    <div id="home" className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <DefaultLayout
        setSearchHeaderKey={null}
        children={
          <div className="max-w-9xl mx-auto bg-white rounded-2xl shadow-xl p-8">
            <h1 className="text-3xl font-bold text-indigo-800 mb-8 text-center">Create Card Template</h1>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
              <div className="space-y-4 bg-indigo-50 p-6 rounded-xl shadow-md">
                <h2 className="text-xl font-semibold text-indigo-700">Code Position</h2>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Top</label>
                  <input
                    type="number"
                    value={cardsPosition?.cardCode?.top}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        cardCode: {
                          ...cardsPosition?.cardCode,
                          top: e.target?.value,
                        },
                      })
                    }
                    onFocus={() => {
                      setActive("code");
                    }}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Left</label>
                  <input
                    type="number"
                    value={cardsPosition?.cardCode?.left}
                    onFocus={() => {
                      setActive("code");
                    }}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        cardCode: {
                          ...cardsPosition?.cardCode,
                          left: e.target?.value,
                        },
                      })
                    }
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Font Size</label>
                  <input
                    type="number"
                    value={cardsPosition?.cardCode?.font}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        cardCode: {
                          ...cardsPosition?.cardCode,
                          font: e.target?.value,
                        },
                      })
                    }
                    onFocus={() => {
                      setActive("code");
                    }}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
              </div>
              <div className="space-y-4 bg-indigo-50 p-6 rounded-xl shadow-md">
                <h2 className="text-xl font-semibold text-indigo-700">Card Dimensions</h2>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Width</label>
                  <input
                    type="number"
                    onFocus={() => {
                      setActive("card");
                    }}
                    value={cardsPosition?.cardImage?.width}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        cardImage: {
                          ...cardsPosition?.cardImage,
                          width: e.target?.value,
                        },
                      })
                    }
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Height</label>
                  <input
                    type="number"
                    onFocus={() => {
                      setActive("card");
                    }}
                    value={cardsPosition?.cardImage?.height}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        cardImage: {
                          ...cardsPosition?.cardImage,
                          height: e.target?.value,
                        },
                      })
                    }
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
              </div>
              <div className="space-y-4 bg-indigo-50 p-6 rounded-xl shadow-md">
                <h2 className="text-xl font-semibold text-indigo-700">ID Position</h2>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Top</label>
                  <input
                    type="number"
                    onFocus={() => {
                      setActive("id");
                    }}
                    value={cardsPosition?.cardId?.top}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        cardId: {
                          ...cardsPosition?.cardId,
                          top: e.target?.value,
                        },
                      })
                    }
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Left</label>
                  <input
                    type="number"
                    onFocus={() => {
                      setActive("id");
                    }}
                    value={cardsPosition?.cardId?.left}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        cardId: {
                          ...cardsPosition?.cardId,
                          left: e.target?.value,
                        },
                      })
                    }
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Font Size</label>
                  <input
                    type="number"
                    onFocus={() => {
                      setActive("id");
                    }}
                    value={cardsPosition?.cardId?.font}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        cardId: {
                          ...cardsPosition?.cardId,
                          font: e.target?.value,
                        },
                      })
                    }
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
              </div>
            </div>
            <form
              onSubmit={(e) => {
                createTemplate(e);
              }}
              className="space-y-6"
            >
              <div className="flex flex-col md:flex-row items-center justify-center gap-8 bg-gradient-to-r from-indigo-100 to-blue-100 p-8 rounded-2xl shadow-lg">
                <div className="w-full md:w-1/3 space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Template Name</label>
                  <Input
                    type={"text"}
                    id={"template_name"}
                    name={"template_name"}
                    defaultValue={newCardData?.order_title}
                    onChange={(e) =>
                      setCardsPosition({
                        ...cardsPosition,
                        templet_name: e.value,
                      })
                    }
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  />
                </div>
                <div className="w-full md:w-1/3 space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Upload Image</label>
                  <input
                    type="file"
                    name="cardImage"
                    onChange={(e) => setSrcObj(e.target?.files[0])}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-500 file:text-white hover:file:bg-indigo-600 transition duration-200"
                  />
                </div>
              </div>
              <div className="flex justify-center">
                <div
                  className={`relative overflow-hidden rounded-3xl shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-indigo-500/50 border-2 ${active == "card" ? "border-red-500" : "border-indigo-300"}`}
                  style={{
                    width: `${cardsPosition?.cardImage?.width}px`,
                    height: `${cardsPosition?.cardImage?.height}px`,
                    backgroundImage: `url(${newSrc})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                  }}
                >
                  <p
                    className="absolute font-bold tracking-[8px] px-1 py-0.5"
                    style={{
                      fontSize: `${cardsPosition?.cardCode?.font}px`,
                      top: `${cardsPosition?.cardCode?.top}px`,
                      left: `${cardsPosition?.cardCode?.left}px`,
                      backgroundColor: active == "code" ? "rgba(255, 0, 0, 0.5)" : "transparent",
                    }}
                  >
                    12287592286296
                  </p>
                  <p
                    className="absolute text-black tracking-[3px] text-center"
                    style={{
                      fontSize: `${cardsPosition?.cardId?.font}px`,
                      top: `${cardsPosition?.cardId?.top}px`,
                      left: `${cardsPosition?.cardId?.left}px`,
                      backgroundColor: active == "id" ? "rgba(255, 0, 0, 0.5)" : "transparent",
                    }}
                  >
                    1701
                  </p>
                </div>
              </div>
              <div className="flex justify-center gap-4 mt-8">
                <button
                  type="button"
                  className="px-8 py-3 bg-green-600 text-white font-bold rounded-full shadow-md hover:bg-green-700 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
                  onClick={() => {
                    localStorage.setItem(
                      "cardsToken",
                      btoa(JSON.stringify({ pos: cardsPosition, src: newSrc }))
                    );
                    window.open("/CardsPreview", "_blank");
                  }}
                >
                  Preview
                </button>
                <button
                  type="submit"
                  className="px-8 py-3 bg-indigo-600 text-white font-bold rounded-full shadow-md hover:bg-indigo-700 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
                >
                  Create Template
                </button>
              </div>
            </form>
          </div>
        }
      />
    </div>
  );
};

export default Cards;